import { BeneficiaryData } from '@app/domain/model/policy/BeneficiaryData';

const MIN_SHARE_PERCENT = 10;
const MAX_SHARE_PERCENT = 90;
const TOTAL_POOL = 100;

interface CalculateAvailableShareParams {
    allBeneficiaries: BeneficiaryData[];
    editingBeneficiaryId: Nullable<string>;
}

export function calculateAvailableShare({
    allBeneficiaries,
    editingBeneficiaryId,
}: CalculateAvailableShareParams): number {
    const otherBeneficiaries = allBeneficiaries.filter(beneficiary => beneficiary.id !== editingBeneficiaryId);

    const otherBeneficiariesTotalShare = otherBeneficiaries.reduce(
        (sum, beneficiary) => sum + Math.round((beneficiary.share || 0) * 100),
        0,
    );

    const availableShare = TOTAL_POOL - otherBeneficiariesTotalShare;

    const hasOtherBeneficiariesWithShare = otherBeneficiaries.some(beneficiary => (beneficiary.share || 0) > 0);

    if (!hasOtherBeneficiariesWithShare) {
        return TOTAL_POOL;
    }

    return Math.max(MIN_SHARE_PERCENT, Math.min(MAX_SHARE_PERCENT, availableShare));
}

export function getBeneficiarySharePercent(beneficiary: Nullable<BeneficiaryData>): number {
    if (!beneficiary) return MIN_SHARE_PERCENT;
    return Math.round((beneficiary.share || 0) * 100);
}
